// extracted by mini-css-extract-plugin
module.exports = {"countdown":"Hf","srOnly":"If"};